import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const OTHER = "__other_option__";

const Choice = ({ type, checked, label, onToggle, testid }) => (
  <button
    type="button"
    role={type === "radio" ? "radio" : "checkbox"}
    aria-checked={checked}
    onClick={onToggle}
    className={`w-full text-left flex items-center gap-2.5 px-3 py-2.5 rounded-md border text-sm transition-colors ${
      checked ? "bg-blue-950/50 border-blue-600 text-slate-50" : "bg-slate-950 border-slate-700 text-slate-300 hover:border-slate-500"
    }`}
    data-testid={testid}
  >
    <span className={`shrink-0 w-4 h-4 border-2 ${type === "radio" ? "rounded-full" : "rounded-sm"} ${checked ? "border-blue-400 bg-blue-500" : "border-slate-500"}`} />
    {label}
  </button>
);

// One Pano audit question. `answer` = { value, other }.
export default function PanoQuestion({ q, answer, onChange }) {
  const value = answer?.value;
  const other = answer?.other || "";
  const tid = `pano-q-${q.entry}`;
  const set = (patch) => onChange({ value, other, ...patch });

  const isChecked = (opt) => (q.type === "checkbox" ? (value || []).includes(opt) : value === opt);
  const toggle = (opt) => {
    if (q.type === "radio") return set({ value: value === opt ? "" : opt });
    const cur = value || [];
    return set({ value: cur.includes(opt) ? cur.filter((x) => x !== opt) : [...cur, opt] });
  };

  return (
    <div className="space-y-2" data-testid={tid}>
      <div className="text-sm font-medium text-slate-100 leading-snug">
        {q.title}
        {q.required && <span className="text-red-400 ml-1" aria-label="required">*</span>}
      </div>
      {q.help && <div className="text-[11px] text-slate-400 leading-snug whitespace-pre-line">{q.help}</div>}

      {q.type === "short" && (
        <Input value={value || ""} onChange={(e) => set({ value: e.target.value })} className="bg-slate-950 border-slate-700" data-testid={`${tid}-input`} />
      )}
      {q.type === "paragraph" && (
        <Textarea value={value || ""} onChange={(e) => set({ value: e.target.value })} rows={3} className="bg-slate-950 border-slate-700" data-testid={`${tid}-input`} />
      )}
      {(q.type === "radio" || q.type === "checkbox") && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5" role={q.type === "radio" ? "radiogroup" : "group"} aria-label={q.title}>
          {q.options.map((opt, i) => (
            <Choice key={opt} type={q.type} checked={isChecked(opt)} label={opt} onToggle={() => toggle(opt)} testid={`${tid}-opt-${i}`} />
          ))}
          {q.other && (
            <Choice type={q.type} checked={isChecked(OTHER)} label="Other…" onToggle={() => toggle(OTHER)} testid={`${tid}-opt-other`} />
          )}
        </div>
      )}
      {q.other && isChecked(OTHER) && (
        <Input
          value={other}
          onChange={(e) => set({ other: e.target.value })}
          placeholder="Describe…"
          className="bg-slate-950 border-slate-700"
          data-testid={`${tid}-other-input`}
        />
      )}
    </div>
  );
}
